
export default {
    // Page Views
    PAGE_VIEW: '$pageview',

    // User Identification
    USER_LOGGED_IN: 'user_logged_in',
    USER_SIGNED_UP: 'user_signed_up',
    USER_PROFILE_UPDATED: 'user_profile_updated',

    // Checklist Interactions
    CHECKLIST_OPENED: 'checklist_opened',
    CHECKLIST_ITEM_CHECKED: 'checklist_item_checked',
    CHECKLIST_COMPLETED: 'checklist_completed',

    // Search
    SEARCH_PERFORMED: 'search_performed',
    SEARCH_RESULT_CLICKED: 'search_result_clicked',

    // Content Engagement
    SCROLL_DEPTH_REACHED: 'scroll_depth_reached', // If manually tracking beyond autocapture
    TIME_ON_PAGE: 'time_on_page',

    // AI Chatbot
    CHAT_STARTED: 'chat_started',
    QUESTION_ASKED: 'question_asked',
    SUGGESTION_CLICKED: 'suggestion_clicked',
    CHAT_ENDED: 'chat_ended',

    // Search - Extended
    SEARCH_FILTER_CLICKED: 'search_filter_clicked',

    // Bookmarks
    BOOKMARK_ADDED: 'bookmark_added',
    BOOKMARK_REMOVED: 'bookmark_removed',
    BOOKMARK_CLICKED: 'bookmark_clicked',

    // Notes
    NOTE_ADDED: 'note_added',
    NOTE_UPDATED: 'note_updated',
    NOTE_DELETED: 'note_deleted',

    // Authentication - Granular
    FORGOT_PASSWORD_REQUESTED: 'forgot_password_requested',

    // Navigation
    NAVIGATION_CLICKED: 'navigation_clicked',
    FOOTER_LINK_CLICKED: 'footer_link_clicked',
    SOCIAL_SHARE_CLICKED: 'social_share_clicked',
    DOWNLOAD_CLICKED: 'download_clicked',

    // Content Engagement
    BLOG_PAGE_OPENED: 'blog_page_opened', // For "Surfing the Brain"
    POPULAR_CATEGORY_CLICKED: 'popular_category_clicked',
    RECENTLY_PUBLISHED_CLICKED: 'recently_published_clicked',
    NEWS_ITEM_CLICKED: 'news_item_clicked',

    CONTACT_FORM_SUBMITTED: 'contact_form_submitted',

    // Specific Funnels
    PRICING_PLAN_CLICKED: 'pricing_plan_clicked',
    BOOK_REGISTRATION_SUBMITTED: 'book_registration_submitted',
    SURFING_BRAIN_PURCHASE_STARTED: 'surfing_brain_purchase_started',
    SURFING_BRAIN_PURCHASE_SUCCESS: 'surfing_brain_purchase_success',


    // Newsletter (on Substack)
    SUBSTACK_SUBSCRIBE_CLICKED: 'substack_subscribe_clicked',
};
